var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 85.434 48.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21023",
    "data-name": "Group 21023",
    transform: "translate(-439 -761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21021",
    "data-name": "Group 21021",
    transform: "translate(29)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1424",
    "data-name": "Ellipse 1424",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(439 761)",
    fill: "#ff4a2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21020",
    "data-name": "Group 21020",
    transform: "translate(220.652 440.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36786",
    "data-name": "Path 36786",
    d: "M232.573,326.517c1.57,0,1.569,0,.912,1.368q-.37.77-.738,1.54a.737.737,0,0,1-.633.491,3.943,3.943,0,0,0-3.74,3.4,4.072,4.072,0,0,0,1.878,4.264,4.023,4.023,0,0,0,4.7-.045c.387-.254.514-.167.7.186.352.665.731,1.316,1.13,1.954.19.3.176.46-.145.673a7.51,7.51,0,1,1-4.066-13.832Z",
    transform: "translate(0)",
    fill: "#fffbfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36787",
    "data-name": "Path 36787",
    d: "M289,385.237c-.56-.965-1.094-1.828-1.566-2.723a.85.85,0,0,0-.906-.516c-1,.034-1.992.011-3.112.011.627-1.082,1.211-2.093,1.8-3.1.115-.2.317-.149.495-.149.957,0,1.914.009,2.871-.007a.618.618,0,0,1,.632.357c.472.853.964,1.7,1.463,2.533a.619.619,0,0,1,0,.72C290.121,383.282,289.591,384.217,289,385.237Z",
    transform: "translate(-51.183 -45.836)",
    fill: "#fffbfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36788",
    "data-name": "Path 36788",
    d: "M305.3,335.676h-.977c-.809,0-.816,0-.684-.82a2.136,2.136,0,0,1,1.03-1.515c.292-.182.607-.328.9-.5.278-.166.51-.394.353-.744a.631.631,0,0,0-.785-.3,1.121,1.121,0,0,0-.625.359c-.165.186-.257.476-.57.112-.235-.273-.428-.45-.1-.8a2.066,2.066,0,0,1,2.623-.3,1.413,1.413,0,0,1-.16,2.363,9.79,9.79,0,0,0-1.3.78c-.085.083-.2.173-.15.307.053.154.205.094.315.1.488.007.978.025,1.465,0,.372-.023.391.179.371.45-.018.248.084.555-.361.533S305.746,335.676,305.3,335.676Z",
    transform: "translate(-68.873 -3.775)",
    fill: "#fffbfa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21022",
    "data-name": "Group 21022",
    transform: "translate(439 797.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21010",
    "data-name": "Group 21010",
    transform: "translate(72.928 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ececec",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ffc813",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21014",
    "data-name": "Group 21014",
    transform: "translate(54.696 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-2",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-2",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-2",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ffc813",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_2",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-2",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-2",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ffc813",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21011",
    "data-name": "Group 21011",
    transform: "translate(36.464 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-3",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-3",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-3",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ffc813",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_3",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-3",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-3",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ffc813",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21012",
    "data-name": "Group 21012",
    transform: "translate(18.232 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-4",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-4",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-4",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ffc813",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_4",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-4",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-4",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ffc813",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21013",
    "data-name": "Group 21013",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-5",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-5",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-5",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ffc813",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_5",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-5",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-5",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ffc813",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG2);
export default __webpack_public_path__ + "static/media/g2.9b91f0779f914515a6631997002afdff.svg";
export { ForwardRef as ReactComponent };